import React, { useState } from 'react';
import { string } from 'prop-types';
import classnames from 'classnames';
import './TopSeoContent.scss';

function TopSeoContent({ values }) {
    const [opened, setOpened] = useState(false);

    function handleClick() {
        setOpened(!opened);
    }

    const contentClassName = classnames('introListing-content', {
        'introListing-content-active': opened,
    });

    return (
        <div className="seo-introListing">
            <div className={contentClassName}>
                {values}
                <button
                    onClick={handleClick}
                    href="#"
                    className="introListing-button"
                >
                    {opened ? 'Afficher moins' : 'Afficher plus'}
                </button>
            </div>
        </div>
    );
}

TopSeoContent.propTypes = {
    values: string.isRequired,
};

export default TopSeoContent;
